import { ReactElement } from 'react';
import './icons.css';

export const GoogleIconSVG = (): ReactElement => (
  <svg width="32" height="34" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 17.3755C32 16.266 31.91 15.1504 31.7181 14.0589H16.3224V20.3443H25.1388C24.7729 22.3715 23.5974 24.1648 21.8761 25.3043V29.3826H27.136C30.2247 26.5398 32 22.3415 32 17.3755Z"
      fill="#4285F4"
    />
    <path
      d="M16.3223 33.3229C20.7246 33.3229 24.437 31.8775 27.1419 29.3825L21.8821 25.3042C20.4187 26.2998 18.5294 26.8636 16.3283 26.8636C12.0701 26.8636 8.45955 23.9907 7.16407 20.1283H1.73628V24.3326C4.50715 29.8443 10.1509 33.3229 16.3223 33.3229Z"
      fill="#34A853"
    />
    <path
      d="M7.15808 20.1282C6.47436 18.101 6.47436 15.9059 7.15808 13.8787V9.67445H1.73629C-0.578764 14.2866 -0.578764 19.7204 1.73629 24.3325L7.15808 20.1282Z"
      fill="#FBBC04"
    />
    <path
      d="M16.3223 7.13756C18.6494 7.10158 20.8985 7.97722 22.5838 9.58457L27.2439 4.92446C24.2931 2.15359 20.3767 0.630213 16.3223 0.678193C10.1509 0.678193 4.50715 4.15678 1.73628 9.67453L7.15807 13.8788C8.44755 10.0104 12.0641 7.13756 16.3223 7.13756Z"
      fill="#EA4335"
    />
  </svg>
);
